// Manifest
import { manifest } from '../../../manifests/questionManifest';
import { IManifestField, IManifestFieldHydrated } from '../../../manifests/types';

export const hydrateManifestSection = (sectionManifest?: IManifestField[]): IManifestFieldHydrated[] => {
    if (!sectionManifest?.length) return [];
    return sectionManifest
        .map((item) => {
            if (!item?.id) return {};
            const additionalProps = Boolean(item?.subManifest?.length)
                ? { subManifest: hydrateManifestSection(item.subManifest) }
                : {};
            const permissions = item?.permission
                ? {
                      permission: item.permission
                  }
                : {};

            return {
                ...item,
                ...manifest[item.id],
                gridSpan: item?.gridSpan ?? manifest[item.id].gridSpan,
                componentProps: {
                    ...(manifest[item.id]?.componentProps ?? {}),
                    ...(item?.componentProps ?? {})
                },
                validator: item?.validator ?? manifest[item.id]?.validator ?? undefined,
                ...additionalProps,
                ...permissions
            };
        })
        .filter(Boolean) as IManifestFieldHydrated[];
};
